import { Box, Typography, IconButton } from '@mui/material';
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DisplayDatabases from '../Components/DbConnection/DisplayDatabases';
import { ConnectionInfo, ConnectionKey, initialState } from '../Components/DbConnection/Data';
import { defaultValuesForDB, getKey } from '../Components/CommonFunctions/CommonFunctions';
import ActionButtons from '../Components/DbConnection/ActionButtons';
import { fontSize } from '..';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import Fields from '../Components/DbConnection/Fields';
import { TDatabase } from '../types/types';
import { Helmet } from 'react-helmet-async';

const NewDBConnection = () => {
  const { parentId } = useParams();
  const navigate = useNavigate();

  const [info, setInfo] = useState(initialState);
  function isModifiedViaJSON(current: ConnectionInfo): boolean {
    const stripIgnored = (obj: ConnectionInfo) => {
      const { port, server, vendor, region, s3Location, database, ...rest } = obj;
      return rest;
    };

    return JSON.stringify(stripIgnored(current)) !== JSON.stringify(stripIgnored(initialState));
  }
  const updateInfo = (label: string, value: any, isFile = false) => {
    const key = getKey(label) as ConnectionKey;
    if (key === 'vendor') {
      setInfo(defaultValuesForDB(value as TDatabase));
      return;
    }
    if (info[key] !== value) {
      setInfo((prev: any) => ({
        ...prev,
        [key]: value,
        ...(isFile && key === 'keystore' ? { keystoreFileName: value.name } : {}),
        ...(isFile && key === 'truststore' ? { truststoreFileName: value.name } : {}),
      }));
    }
  };
  return (
    <>
      <Helmet prioritizeSeoTags defer>
        <title>New DB Connection | Silzila</title>
      </Helmet>
      <Box sx={{ display: 'flex', height: '100%' }}>
        <DisplayDatabases
          onClick={updateInfo}
          selectedDb={info.vendor}
          hasModified={isModifiedViaJSON(info)}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1.25,
            flex: 1,
          }}
        >
          <Box
            sx={{
              flex: 1,
              position: 'relative',
              overflowY: 'auto',
              overflowX: 'hidden',
            }}
          >
            {' '}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                position: 'sticky',
                top: 6,
                backgroundColor: 'white',
                zIndex: 1,
                pb: 2,
              }}
            >
              <IconButton onClick={() => navigate(-1)} size="small">
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="body1" sx={{ cursor: 'pointer' }} onClick={() => navigate(-1)}>
                Back
              </Typography>
            </Box>
            {!info?.vendor ? (
              <span
                // variant="h6"
                style={{
                  fontSize: fontSize.extraLarge,
                  paddingBlock: '0.5rem',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
              >
                Please select a database
              </span>
            ) : (
              <>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: fontSize.extraLarge,
                    paddingBlock: '0.5rem',
                    mb: 2,
                    position: 'sticky',
                    top: 0,
                    backgroundColor: 'white',
                  }}
                >
                  Create DB Connection
                </Typography>
                <Fields info={info} updateValues={updateInfo} viewMode={false} />
              </>
            )}
          </Box>
          {info.vendor && (
            <Box
              sx={{
                height: '3rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <ActionButtons
                viewMode={false}
                setViewMode={() => {}}
                disableEdit={false}
                info={info}
                workspaceId={parentId!}
              />
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};

export default NewDBConnection;
